import Toggle from "react-toggle";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  selectLeaseStatus,
  toggleLeaseStatus,
} from "../../../redux/reducers/leaseStatusSlice";
import "./LeaseFilter.scss";
import { Item } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import { LEASE_STATUS } from "../../../common/constants";
import classNames from "classnames";

function LeaseFilter() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectLeaseStatus);

  const toggleSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    filters.forEach((filter) => {
      if (filter.name == e.currentTarget.value) {
        dispatch(toggleLeaseStatus(filter.name));
      }
    });
  };

  return (
    <section>
      {filters
        .filter(
          (filter) =>
            filter.name != LEASE_STATUS.NONE &&
            filter.name != LEASE_STATUS.DUMMY
        )
        .map((filter, index) => {
          return (
            <Item key={filter.name} id={filter.name} style={{ width: "222px" }} closeOnClick={false}>
              <span
                className={classNames("menu-status-text", "context-menu-text")}
              >
                {filter.text}
              </span>
              <div style={{ marginLeft: "auto" }}>
                <Toggle
                  checked={filter["selected"]}
                  value={filter["name"]}
                  onChange={toggleSelection}
                  icons={false}
                ></Toggle>
              </div>
            </Item>
          );
        })}
    </section>
  );
}

export default LeaseFilter;
